// extracted by mini-css-extract-plugin
export var columnItems = "footer-module--columnItems--4793c";
export var header = "footer-module--header--a198d";
export var segment = "footer-module--segment--b3ddd";
export var socialMediaIcon = "footer-module--socialMediaIcon--f629b";
export var text = "footer-module--text--9f7c9";